import { setEventBus } from '~/store'

export default defineNuxtPlugin((nuxtApp) => {
  setEventBus(nuxtApp.$eventbus)
})